import React from 'react'
import Fragment from '../common/fragment'


function FragmentCE(props) {
  return (
    <Fragment pos="eee" {...props}>
      <p>
En Salamanca perdí la conciencia y desperté a las horas, adolorido y
desconcertado. En una convulsión todo es negro, pero Cristo no aparece. Negro el
interior del cuerpo y negra la repentina lucidez. Negro sobrenegro sobrenegro
sobrenegro. Como un cuadro de Malevich que se derramara sobre nuestros cuerpos, en los templos, al amanecer, sobre nuestros cuerpos. Nunca encontré nada: ni dioses, ni fulgor, ni
piedras. Luz y luego negro, como el cuadro de Malevich.
      </p>
    </Fragment>
  )
}


export default FragmentCE
